import { useContext } from "react";
import { SignedInContext } from "../AppEnv";
import { SignedInDoctor } from "../auth/interfaces";
import {
  EXAM_4PHOTOS_SLUGNAME,
  EXAM_AAII_SLUGNAME,
  EXAM_BALANCE_SLUGNAME,
  EXAM_MAGNO_SLUGNAME,
  EXAM_PODO_SLUGNAME,
  EXAM_PODO_STIM_SLUGNAME,
  EXAM_VISION_SLUGNAME,
  EXAM_HEAD_SLUGNAME,
  EXAM_FUKUDA_SLUGNAME,
  EXAM_ADAMS_SLUGNAME,
  EXAM_ROMBERG_SLUGNAME,
  EXAM_RATE_SLUGNAME,
  EXAM_ANAM_SLUGNAME,
  EXAM_TINETTI_SLUGNAME,
  EXAM_ELICOIDALE_SLUGNAME,
} from "./exams_definitions_utils";
import { PosturalExamination, PosturalTestDefinition } from "./interfaces";
import PosturalExam4PhotosRight from "./PosturalExam4PhotosRight";
import PosturalExamAAIIRight from "./PosturalExamAAIIRight";
import PosturalExamBalanceRight from "./PosturalExamBalanceRight";
import PosturalExamMagnoRight from "./PosturalExamMagnoRight";
import PosturalExamHeadRight from "./PosturalExamHeadRight";
import PosturalExamPodoRight from "./PosturalExamPodoRight";
import PosturalExamPodoStimRight from "./PosturalExamPodoStimRight";
import PosturalExamVisionRight from "./PosturalExamVisionRight";
import PosturalExamFukudaRight from "./PosturalExamFukudaRight";
import PosturalExamAdamsRight from "./PosturalExamAdamsRight";
import PosturalExamRombergRight from "./PosturalExamRombergRight";
import PosturalExamTinettiRight from "./PosturalExamTinettiRight";
import PosturalExamRateRight from "./PosturalExamRateRight";
import { TakenPhoto } from "./PosturalExamWrapper";
import { editPosturalTestSelection } from "./utils";
import PosturalExamAnamRight from "./PosturalExamAnamRight";
import PosturalExamElicoidaleRight from "./PosturalExamElicoidaleRight";

const PerformExam = ({
  page,
  images,
  getWebcamPhoto,
  loadPhoto,
  testDefinitions,
  posturalExamination,
  setPosturalExamination,
  justCreated,
}: {
  page: number;
  images: TakenPhoto[];
  getWebcamPhoto: Function;
  loadPhoto: Function;
  testDefinitions: PosturalTestDefinition[];
  posturalExamination: PosturalExamination;
  setPosturalExamination: Function;
  justCreated: boolean;
}) => {
  const signedInDoctor: SignedInDoctor =
    useContext(SignedInContext).signedInDoctor;

  // Recover test selection
  const setTestSelection = (
    testIndex: number,
    testSelection: number,
    note: string
  ) => {
    //console.log(testIndex, testSelection, note);
    setPosturalExamination((currPE: PosturalExamination) => {
      if (currPE.testSelections)
        for (let i = 0; i < currPE.testSelections.length; i++)
          if (currPE.testSelections[i].testId == testIndex) {
            currPE.testSelections[i].selectedValue = testSelection;
            currPE.testSelections[i].note = note;
          }
      return { ...currPE };
    });
    editPosturalTestSelection(
      signedInDoctor,
      posturalExamination.patientId,
      posturalExamination.examId,
      testIndex,
      testSelection,
      note
    ).then((msg) => {
      if (msg.indexOf("error"))
        alert("Impossibile sincronizzare i dati: riprova più tardi");
    });
  };

  switch (posturalExamination.type) {
    case EXAM_4PHOTOS_SLUGNAME:
      return (
        <PosturalExam4PhotosRight 
          page={page}
          images={images}
          getWebcamPhoto={getWebcamPhoto}
          loadPhoto={loadPhoto}
          posturalExamination={posturalExamination}
          setTestSelection={setTestSelection}
          testDefinitions={testDefinitions}
        />
      );
    case EXAM_PODO_SLUGNAME:
      return (
        <PosturalExamPodoRight
          page={page}
          images={images}
          getWebcamPhoto={getWebcamPhoto}
          loadPhoto={loadPhoto}
          posturalExamination={posturalExamination}
          setTestSelection={setTestSelection}
          testDefinitions={testDefinitions}
        />
      );
    case EXAM_PODO_STIM_SLUGNAME:
      return (
        <PosturalExamPodoStimRight
          page={page}
          images={images}
          getWebcamPhoto={getWebcamPhoto}
          loadPhoto={loadPhoto}
          posturalExamination={posturalExamination}
          setTestSelection={setTestSelection}
          testDefinitions={testDefinitions}
        />
      );
    case EXAM_AAII_SLUGNAME:
      return (
        <PosturalExamAAIIRight
          page={page}
          images={images}
          getWebcamPhoto={getWebcamPhoto}
          loadPhoto={loadPhoto}
          posturalExamination={posturalExamination}
          setTestSelection={setTestSelection}
          testDefinitions={testDefinitions}
        />
      );
    case EXAM_VISION_SLUGNAME:
      return (
        <PosturalExamVisionRight
          page={page}
          images={images}
          getWebcamPhoto={getWebcamPhoto}
          loadPhoto={loadPhoto}
          posturalExamination={posturalExamination}
          setTestSelection={setTestSelection}
          testDefinitions={testDefinitions}
        />
      );
    case EXAM_BALANCE_SLUGNAME:
      return (
        <PosturalExamBalanceRight
          page={page}
          images={images}
          getWebcamPhoto={getWebcamPhoto}
          loadPhoto={loadPhoto}
          posturalExamination={posturalExamination}
          setTestSelection={setTestSelection}
          testDefinitions={testDefinitions}
        />
      );
    case EXAM_MAGNO_SLUGNAME:
      return (
        <PosturalExamMagnoRight
          page={page}
          images={images}
          getWebcamPhoto={getWebcamPhoto}
          loadPhoto={loadPhoto}
          posturalExamination={posturalExamination}
          setTestSelection={setTestSelection}
          testDefinitions={testDefinitions}
        />
      );
    case EXAM_HEAD_SLUGNAME:
      return (
        <PosturalExamHeadRight
          page={page}
          images={images}
          getWebcamPhoto={getWebcamPhoto}
          loadPhoto={loadPhoto}
          posturalExamination={posturalExamination}
          setTestSelection={setTestSelection}
          testDefinitions={testDefinitions}
        />
      );
    case EXAM_FUKUDA_SLUGNAME:
      return (
        <PosturalExamFukudaRight
          page={page}
          images={images}
          getWebcamPhoto={getWebcamPhoto}
          loadPhoto={loadPhoto}
          posturalExamination={posturalExamination}
          setTestSelection={setTestSelection}
          testDefinitions={testDefinitions}
          justCreated={justCreated}
        />
      );
    case EXAM_ADAMS_SLUGNAME:
      return (
        <PosturalExamAdamsRight
          page={page}
          images={images}
          getWebcamPhoto={getWebcamPhoto}
          loadPhoto={loadPhoto}
          posturalExamination={posturalExamination}
          setTestSelection={setTestSelection}
          testDefinitions={testDefinitions}
        />
      );
    case EXAM_ROMBERG_SLUGNAME:
      return (
        <PosturalExamRombergRight
          page={page}
          images={images}
          getWebcamPhoto={getWebcamPhoto}
          loadPhoto={loadPhoto}
          posturalExamination={posturalExamination}
          setTestSelection={setTestSelection}
          testDefinitions={testDefinitions}
          justCreated={justCreated}
        />
      );
    case EXAM_RATE_SLUGNAME:
      return (
        <PosturalExamRateRight
          page={page}
          posturalExamination={posturalExamination}
          setTestSelection={setTestSelection}
          testDefinitions={testDefinitions}
          justCreated={justCreated}
        />
      );
    case EXAM_ANAM_SLUGNAME:
      return (
        <PosturalExamAnamRight
          page={page}
          posturalExamination={posturalExamination}
          setTestSelection={setTestSelection}
          testDefinitions={testDefinitions}
        />
      );
    case EXAM_TINETTI_SLUGNAME:
      return (
        <PosturalExamTinettiRight
          page={page}
          posturalExamination={posturalExamination}
          setTestSelection={setTestSelection}
          testDefinitions={testDefinitions}
          justCreated={justCreated}
        />
      );
    case EXAM_ELICOIDALE_SLUGNAME:
      return (
        <PosturalExamElicoidaleRight
          page={page}
          images={images}
          getWebcamPhoto={getWebcamPhoto}
          loadPhoto={loadPhoto}
          posturalExamination={posturalExamination}
          setTestSelection={setTestSelection}
          testDefinitions={testDefinitions}
          justCreated={justCreated}
        />
      );
    default:
      return <>Esame ancora in via di sviluppo, presto sarà supportato ;-)</>;
  }
};
export default PerformExam;
